// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jsQHA{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:16px}.jsQHA>.form-group{-ms-flex:1 1 100%;flex:1 1 100%}@media (min-width:600px){.jsQHA>.form-group{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;-ms-flex-preferred-size:calc(50% - 8px);flex-basis:calc(50% - 8px)}}", ""]);
// Exports
exports.locals = {
	"phiSetFormPartial": "jsQHA"
};
module.exports = exports;
